module.exports = __webpack_public_path__ + "src/img/artist/name_bg.png?d8f12a5464510ef9849216aba237fe85";


//////////////////
// WEBPACK FOOTER
// ./src/img/artist/name_bg.png
// module id = 146
// module chunks = 0